import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalNavigationComponent } from '../modal-navigation-component';
import { ModalNavigationService } from '../modal-navigation.service';
import { SbModalState } from '../modal-state.service';
import { Options } from '../modal.model';

@Component({
  selector: 'sb-navigation-modal',
  templateUrl: './sb-navigation-modal.component.html',
  styleUrls: ['./sb-navigation-modal.component.scss'],
  standalone: false,
})
export class SbNavigationModalComponent<T> implements OnInit, OnDestroy {
  options: Options<T>;
  @Input()
  templateId: string;

  private sub: any;

  _modalNavigationDirective: ViewContainerRef;

  @ViewChild('themodalnav', { read: ViewContainerRef, static: true })
  set modalNavigationDirective(val) {
    this._modalNavigationDirective = val;
    this.sub = this.modalNavigation.onNavigation.subscribe((e: any) => {
      this.loadComponent(this.state.navigationStack.peek().value);
    });
    this.loadComponent(this.state.navigationStack.peek().value);
  }

  get modalNavigationDirective(): ViewContainerRef {
    return this._modalNavigationDirective;
  }

  ngOnInit() {
    this.options = this.state.options.get(this.templateId);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.modalNavigation.clear();
  }

  constructor(
    private state: SbModalState,
    private componentFactoryResolver: ComponentFactoryResolver,
    private modalNavigation: ModalNavigationService
  ) {}

  loadComponent(component: Type<any>) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

    const viewContainerRef = this.modalNavigationDirective;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    const instance: ModalNavigationComponent = componentRef.instance as ModalNavigationComponent;
    instance.isInModalContext = true;
    this.state.navigationStack.peek().componentInstance = instance;
  }

  canGoBack(): boolean {
    return this.modalNavigation.canGoBack();
  }

  goBack() {
    if (this.canGoBack()) {
      this.modalNavigation.goBack();
    }
  }

  getBackClass() {
    return this.canGoBack() ? '' : 'disabled';
  }
}
